import { useLocation, useOutletContext } from "react-router-dom"
import { ButtonCreate, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from "../../../../components/styles/subheader-style"
import { RouterOutletType } from "../index2"
import React, { useContext } from "react"
import ModalContext from "../../../../contexts/ModalContext"
import { useNavigate } from "react-router-dom";
import { FreightContext } from "../../../../contexts/FreightContext"
import { VehicleContext } from "../../../../contexts/VehicleContext"


// NOTAS:
// Esse componente(botão) terá n funções, de acordo com o tabIndex ou o path 
// da Route, o onCLick do booão mudará, tal qual o seu nome/estilo

const RouterButtons:React.FC<{index:number}> = ({index})=>{
    const { setModalActive, setModalSection } = useContext(ModalContext);
    const {setFreight} = useContext(FreightContext)
    const {setVehicle} = useContext(VehicleContext)
    const navigate = useNavigate() 
    const location = useLocation();
    const criarFrete = ()=>{
      handleClick("Freight")
      navigate("/panel/router/create")
}

const handleClick = (tab: string)=>{
  setFreight(null)
  setVehicle(null)
  // setModalSection('router' + tab + 'Form');
  // setModalActive(true);
}
const criarRota = ()=>{
   navigate("/panel/router/routers/create")
  
}
const criarVeiculo = ()=>{
    
    navigate('/panel/equipment/create')
    
}
    const buttonProps = [
        {name: "+ Criar frete", action: criarFrete},
        {name: "+ Criar rota", action: criarRota},
        {name: "+ Criar veiculo", action: criarVeiculo},
        {name: "+ Criar Data"}
    ]
return (
  <>
    {location.pathname === '/panel/equipment' ?
    <ButtonCreate onClick={() => buttonProps[2]?.action?.()}>{buttonProps[2]?.name}</ButtonCreate>
    :
    <ButtonCreate onClick={() => buttonProps[index]?.action?.()}>{buttonProps[index]?.name}</ButtonCreate>
    }
    
  </>
)
}
export default RouterButtons